import { makeVar } from "@apollo/client";

/**
 * A reactive apollo variable for the positions queried payment preference, to enable easy updates
 * of the query after edit or create operations.
 *
 * @see https://www.apollographql.com/docs/react/local-state/reactive-variables
 */
export const positionPaymentPrefVar = makeVar<string | null>(null);
